import { detectLocale } from "@blockdaemon/widget-host";
import { i18n } from "@lingui/core";
import type { ReactNode } from "react";

import { useWidgetConfig } from "../../features/customization/hooks/use-widget-config";

interface LocaleConfigWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component that reads locale config from widget config
 * and updates the locale accordingly. Assumes I18nProvider is already
 * provided higher up in the component tree.
 *
 * Must render inside {@link WidgetConfigProvider} (see routes/__root.tsx).
 */
export function LocaleConfigWrapper({ children }: LocaleConfigWrapperProps) {
  const { config } = useWidgetConfig();

  // Extract locale config from appearance settings
  const configLocale = config?.appearance?.locale;

  if (configLocale) {
    const locale = detectLocale(configLocale);
    if (i18n.locale !== locale) {
      i18n.activate(locale);
      localStorage.setItem("widget-locale", locale);
    }
  }

  return <>{children}</>;
}
